"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f114 = void 0;
exports.f114 = {
    "raa": [
        "Deva"
    ],
    "rab": [
        "Deva"
    ],
    "rac": [
        "Latn"
    ],
    "rad": [
        "Latn"
    ],
    "raf": [
        "Deva"
    ],
    "rag": [
        "Latn"
    ],
    "rah": [
        "Beng",
        "Latn"
    ],
    "rai": [
        "Latn"
    ],
    "raj": [
        "Deva",
        "Latn"
    ],
    "rak": [
        "Latn"
    ],
    "ral": [
        "Zyyy"
    ],
    "ram": [
        "Latn"
    ],
    "ran": [
        "Latn"
    ],
    "rao": [
        "Latn"
    ],
    "rap": [
        "Latn"
    ],
    "raq": [
        "Zyyy"
    ],
    "rar": [
        "Latn"
    ],
    "ras": [
        "Zyyy"
    ],
    "rat": [
        "Zyyy"
    ],
    "rau": [
        "Zyyy"
    ],
    "rav": [
        "Deva"
    ],
    "raw": [
        "Latn"
    ],
    "rax": [
        "Latn"
    ],
    "ray": [
        "Latn"
    ],
    "raz": [
        "Latn"
    ],
    "rbb": [
        "Mymr"
    ],
    "rbk": [
        "Latn"
    ],
    "rbl": [
        "Latn"
    ],
    "rbp": [
        "Latn"
    ],
    "rcf": [
        "Latn"
    ],
    "rdb": [
        "Arab"
    ],
    "rea": [
        "Latn"
    ],
    "reb": [
        "Latn"
    ],
    "ree": [
        "Latn"
    ],
    "reg": [
        "Latn"
    ],
    "rei": [
        "Zyyy"
    ],
    "rej": [
        "Latn",
        "Rjng"
    ],
    "rel": [
        "Latn"
    ],
    "rem": [
        "Latn"
    ],
    "ren": [
        "Latn"
    ],
    "rer": [
        "Zyyy"
    ],
    "res": [
        "Latn"
    ],
    "ret": [
        "Latn"
    ],
    "rey": [
        "Latn"
    ],
    "rga": [
        "Latn"
    ],
    "rge": [
        "Zyyy"
    ],
    "rgk": [
        "Zyyy"
    ],
    "rgn": [
        "Latn"
    ],
    "rgr": [
        "Latn"
    ],
    "rgs": [
        "Latn"
    ],
    "rgu": [
        "Latn"
    ],
    "rhg": [
        "Arab",
        "Latn",
        "Rohg"
    ],
    "rhp": [
        "Latn"
    ],
    "ria": [
        "Latn"
    ],
    "rie": [
        "Zyyy"
    ],
    "rif": [
        "Tfng",
        "Arab",
        "Latn"
    ],
    "ril": [
        "Latn"
    ],
    "rim": [
        "Latn"
    ],
    "rin": [
        "Latn"
    ],
    "rir": [
        "Latn"
    ],
    "rit": [
        "Latn"
    ],
    "riu": [
        "Latn"
    ],
    "rjg": [
        "Latn"
    ],
    "rji": [
        "Deva"
    ],
    "rjs": [
        "Deva"
    ],
    "rka": [
        "Khmr"
    ],
    "rkb": [
        "Latn"
    ],
    "rkh": [
        "Latn"
    ],
    "rki": [
        "Mymr"
    ],
    "rkm": [
        "Latn"
    ],
    "rkt": [
        "Beng"
    ],
    "rkw": [
        "Latn"
    ],
    "rm": [
        "Latn"
    ],
    "rma": [
        "Latn"
    ],
    "rmb": [
        "Latn"
    ],
    "rmc": [
        "Latn"
    ],
    "rmd": [
        "Latn"
    ],
    "rme": [
        "Latn"
    ],
    "rmf": [
        "Latn"
    ],
    "rmg": [
        "Latn"
    ],
    "rmh": [
        "Latn"
    ],
    "rmi": [
        "Armn"
    ],
    "rmk": [
        "Latn"
    ],
    "rml": [
        "Latn",
        "Cyrl"
    ],
    "rmm": [
        "Latn"
    ],
    "rmn": [
        "Latn",
        "Cyrl",
        "Grek"
    ],
    "rmo": [
        "Latn"
    ],
    "rmp": [
        "Latn"
    ],
    "rmq": [
        "Latn"
    ],
    "rms": [
        "Zxxx"
    ],
    "rmt": [
        "Arab"
    ],
    "rmu": [
        "Latn"
    ],
    "rmv": [
        "Zyyy"
    ],
    "rmw": [
        "Latn"
    ],
    "rmx": [
        "Latn"
    ],
    "rmz": [
        "Mymr"
    ],
    "rn": [
        "Latn",
        "Brai"
    ],
    "rnd": [
        "Latn"
    ],
    "rng": [
        "Latn"
    ],
    "rnl": [
        "Latn"
    ],
    "rnn": [
        "Latn"
    ],
    "rnp": [
        "Zyyy"
    ],
    "rnr": [
        "Latn"
    ],
    "rnw": [
        "Latn"
    ],
    "ro": [
        "Latn",
        "Brai",
        "Cyrl",
        "Cyrs",
        "Dupl"
    ],
    "rob": [
        "Latn"
    ],
    "roc": [
        "Latn"
    ],
    "rod": [
        "Latn"
    ],
    "roe": [
        "Latn"
    ],
    "rof": [
        "Latn"
    ],
    "rog": [
        "Latn"
    ],
    "rol": [
        "Latn"
    ],
    "rom": [
        "Latn",
        "Cyrl"
    ],
    "roo": [
        "Latn"
    ],
    "rop": [
        "Latn"
    ],
    "ror": [
        "Latn"
    ],
    "rou": [
        "Latn"
    ],
    "row": [
        "Latn"
    ],
    "rpn": [
        "Latn"
    ],
    "rpt": [
        "Latn"
    ],
    "rri": [
        "Latn"
    ],
    "rro": [
        "Latn"
    ],
    "rrt": [
        "Latn"
    ],
    "rsb": [
        "Zyyy"
    ],
    "rsi": [
        "Zxxx"
    ],
    "rsl": [
        "Zxxx"
    ],
    "rsm": [
        "Zxxx"
    ],
    "rtc": [
        "Latn"
    ],
    "rth": [
        "Latn"
    ],
    "rtm": [
        "Latn"
    ],
    "rts": [
        "Zyyy"
    ],
    "rtw": [
        "Deva"
    ],
    "ru": [
        "Cyrl",
        "Brai"
    ],
    "rub": [
        "Latn"
    ],
    "ruc": [
        "Latn"
    ],
    "rue": [
        "Cyrl",
        "Latn"
    ],
    "ruf": [
        "Latn"
    ],
    "rug": [
        "Latn"
    ],
    "ruh": [
        "Zyyy"
    ],
    "rui": [
        "Latn"
    ],
    "ruk": [
        "Latn"
    ],
    "ruo": [
        "Latn"
    ],
    "rup": [
        "Latn",
        "Grek"
    ],
    "ruq": [
        "Latn"
    ],
    "rut": [
        "Cyrl",
        "Latn"
    ],
    "ruu": [
        "Latn"
    ],
    "ruy": [
        "Latn"
    ],
    "ruz": [
        "Latn"
    ],
    "rw": [
        "Latn",
        "Brai"
    ],
    "rwa": [
        "Latn"
    ],
    "rwk": [
        "Latn"
    ],
    "rwl": [
        "Latn"
    ],
    "rwm": [
        "Latn"
    ],
    "rwo": [
        "Latn"
    ],
    "rwr": [
        "Deva"
    ],
    "rxd": [
        "Latn"
    ],
    "rxw": [
        "Latn"
    ],
    "ryn": [
        "Zyyy"
    ],
    "rys": [
        "Zyyy"
    ],
    "ryu": [
        "Kana"
    ],
    "rzh": [
        "Zyyy"
    ]
};
